import { Pagination } from '@/typings/common';
import { get, post } from '@/utils/request/mAxios';
import { EnumPackage } from '../type/enumType';
import APIs from './index';

export function createEnumPackage(pkg: Omit<EnumPackage, 'id'>) {
  return post<{
    enumPackageId: string;
  }>(APIs.createEnumPackage, pkg);
}

export interface GetEnumPackageReqParam {
  teamId?: string;
  enumPackageId?: string;
  keyword?: string;
  page?: number;
  pageSize?: number;
}

export function getEnumPackage(reqParams: GetEnumPackageReqParam) {
  return get<{
    list: EnumPackage[];
    pageInfo: Pagination;
  }>(APIs.getEnumPackage, reqParams);
}

export function updateEnumPackage(reqParams: EnumPackage & {
  enumPackageId: string;
}) {
  return post(APIs.updateEnumPackage, reqParams);
}

export function deleteEnumPackage(reqParams: {
  teamId: string;
  enumPackageId: string;
}) {
  return post(APIs.deleteEnumPackage, reqParams);
}

export function updateInterfaceWhenEnumExpired(reqParams: {
  teamId: string;
  enumPackageId: string;
  interfaceList: string[];
}) {
  return post(APIs.updateInterfaceWhenEnumExpired, reqParams);
}

export function getInterfaceBindingEnumPackage(reqParams: {
  teamId: string;
  serviceId: string;
  environmentId: string;
  interfaceId: string;
}) {
  return get<{
    list: EnumPackage[];
  }>(APIs.getInterfaceBindingEnumPackage, reqParams);
}

export function updateInterfaceBindingEnumPackage(reqParams: {
  teamId: string;
  serviceId: string;
  environmentId: string;
  interfaceId: string;
  enumPackageList: string[];
}) {
  return post(APIs.updateInterfaceBindingEnumPackage, reqParams);
}

/**
 * 获取枚举包代码(Thrift格式)
 * @param reqParams teamId&&environmentId
 */
export function getEnumPackageExport(reqParams: {
  teamId: string;
  enumPackageId: string;
}) {
  return get<{
    enumPackageContent: string;
  }>(APIs.getEnumPackageExport, reqParams);
}
